import { useState, useRef } from "react";

import { Menu } from "primereact/menu";
import { Avatar } from "primereact/avatar";
import { useAuthContext } from "../context/AuthContext";
import ResetPassword from "../Pages/ResetPassword";

const AppHeader = () => {
  const { currentUser } = useAuthContext();
  const [showResetPassword, setShowResetPassword] = useState(false);
  const menu = useRef<Menu>(null);

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("loggedIn");
    window.location.href = "/";
  };

  const menuItems = [
    {
      label: "Reset Password",
      icon: "pi pi-key",
      command: () => setShowResetPassword(true),
    },
    {
      separator: true,
    },
    {
      label: "Logout",
      icon: "pi pi-sign-out",
      command: handleLogout,
    },
  ];

  return (
    <>
      <header className="surface-0 shadow-2 px-3 py-2 mb-4">
        <div className="flex align-items-center justify-content-between">
          <div className="flex align-items-center gap-2">
            <img
              src="/images/saas-innova-logo.png"
              alt="Company Logo"
              className="h-3rem"
            />
          </div>

          {currentUser && (
            <div className="flex align-items-center gap-3">
              <div
                className="flex align-items-center gap-2 cursor-pointer p-2 border-round hover:surface-100 transition-colors transition-duration-150"
                onClick={(e) => menu.current?.toggle(e)}>
                <Avatar
                  label={currentUser.username.charAt(0).toUpperCase()}
                  size="normal"
                  shape="circle"
                  className="bg-primary"
                />
                <div className="flex flex-column">
                  <span className="text-sm font-medium text-900">
                    {currentUser.username}
                  </span>
                  <span className="text-xs text-500">Logged in</span>
                </div>
                <i className="pi pi-angle-down text-500" />
              </div>

              <Menu model={menuItems} popup ref={menu} />
            </div>
          )}
        </div>
      </header>

      <ResetPassword
        visible={showResetPassword}
        onHide={() => setShowResetPassword(false)}
      />
    </>
  );
};

export default AppHeader;

